import angular from "angular";

import { Ng1StateDeclaration, StateProvider } from "@uirouter/angularjs";
import {
  vsProviderName as MachineDetailTabsProviderName,
  MachineDetailTabsProvider,
} from "../../../../../../machines/shared/components/views/machines/detail/tabs";
import { vsModuleName as machinesSharedModule } from "../../../../../../machines/shared";
import {
  GridConfiguration,
  RecordGridViewService,
  vsComponentName as RecordGridViewComponentName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../../records/views/recordGridView";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../../../records/grids/settings/gridSettingsService";
import uiRouter, { StateParams } from "@uirouter/angularjs/lib-esm";
import { vsObjectName as contractObjectName } from "../../../../../configs/contract";
import { moduleName as recordsModuleName } from "../../../../../../records";
import { RecordDataSource } from "../../../../../../records/grids";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../records/server/serverUtility";

export const vsModuleName = "machine.detail.contract";
const moduleSymbol = Symbol(vsModuleName);

export function registerMachineContractDetailTab() {
  const module = angular.module(
    vsModuleName,
    [machinesSharedModule, recordsModuleName],
    [
      MachineDetailTabsProviderName,
      (machineDetailTabsProvider: MachineDetailTabsProvider) =>
        machineDetailTabsProvider.addElement({
          displayName: "Contracts",
          uiSrefFragment: "contracts",
          requiredPermission: "contractView",
          stateDefinition: getState(moduleSymbol),
          id: "contracts",
        }),
    ]
  );

  return module.name;
}

export function registerMachineContractDetailState(stateName: string) {
  const module = angular.module(
    vsModuleName,
    [uiRouter, recordsModuleName],
    [
      "$stateProvider",
      ($stateProvider: StateProvider) =>
        $stateProvider.state(stateName, getState(moduleSymbol)),
    ]
  );

  return module.name;
}

function getState(settingsId: symbol): Ng1StateDeclaration {
  return {
    url: "/contracts",
    component: RecordGridViewComponentName,
    resolve: {
      gridConfiguration: [
        RecordGridViewServiceName,
        (recordGridViewService: RecordGridViewService) =>
          recordGridViewService.getGridConfiguration(contractObjectName),
      ],
      gridDataSource: [
        ServerUtilityName,
        (serverUtility: ServerUtility) =>
          new RecordDataSource(serverUtility, "/api/contract/contractMachines"),
      ],
      gridSettings: [
        GridSettingsServiceName,
        (gridSettingsService: GridSettingsService) =>
          gridSettingsService.getGridSettings(settingsId),
      ],
      columns: [
        "gridConfiguration",
        (gridConfiguration: GridConfiguration) =>
          gridConfiguration.columns ?? [],
      ],
      machineId: [
        "$stateParams",
        ($stateParams: StateParams) => $stateParams["machineId"],
      ],
      defaultQuery: [
        "machineId",
        (machineId: number) => {
          return {
            MachineId: machineId,
          };
        },
      ],
      nameSingular: [() => "Contract"],
      defaultSort: [
        "gridConfiguration",
        (gridConfiguration: GridConfiguration) => gridConfiguration.defaultSort,
      ],
    },
  };
}
